import { KEY_CODE } from "../constants";

export default function isEnterorSpaceKeyPressed(event) {
    if((event && event.keyCode && (event.keyCode === KEY_CODE.ENTER_KEY || event.keyCode === KEY_CODE.SPACE_KEY)) || 
        (!event) ||      //this is used because of on mouse click event some of functions we didn't get the event
        (event.type === "click")){   //this is used because of on mouse click event some of functions we get the event so we captured the type of event
        return true;
    }
    return false;
  }